import dynaForms from '@elab/core/utils/dynaForms';
import { reduceAction } from '@elab/core/store/helpers';
import { initialState as dynaInitialState } from '@elab/core/utils/dynaForms/reducers';

import getTypes from './types';

export const initialState = (state, initialData) => ({
    ...dynaInitialState(state),
    registeredUser: {},
    isAgeVerified: false,
    isPinCodeOrDOBValid: true,
    isPinCodeAndDOBFilled: false,
    isLoyaltyPhone: false,
    showPincode: false,
    disableStep1Button: false,
    ...initialData,
});

const setTempValidation = (state, payload, validator) => {
    if (state && state.data && state.data[validator]) {
        const typeExist =
            state.data[validator].constraints &&
            state.data[validator].constraints.find(constraint => constraint.type == 'required');
        if (!typeExist) {
            return {
                ...state,
                data: {
                    ...state.data,
                    [validator]: {
                        ...state.data[validator],
                        constraints: [payload, ...(state.data[validator].constraints || [])],
                        required: true,
                    },
                },
            };
        }
    }
    return {
        ...state,
    };
};

const toggleFakeValidationsForRegistration = (state, { isLoyalty, forceReadOnly }) => {
    return {
        ...state,
        isLoyaltyPhone: isLoyalty,
        data: {
            ...state.data,
            uid: {
                ...state.data.uid,
                readOnly: forceReadOnly,
            },
            firstName: {
                ...state.data.firstName,
                readOnly: forceReadOnly,
            },
            lastName: {
                ...state.data.lastName,
                readOnly: forceReadOnly,
            },
            communication: {
                ...state.data.communication,
                readOnly: forceReadOnly,
            },
            personalInfo: {
                ...state.data.personalInfo,
                readOnly: forceReadOnly,
            },
            password: {
                ...state.data.password,
                readOnly: forceReadOnly,
            },
            passwordConfirm: {
                ...state.data.passwordConfirm,
                readOnly: forceReadOnly,
            },
            mobileNumber: {
                ...state.data.mobileNumber,
                readOnly: forceReadOnly,
            },
        },
    };
};

export const createReducer = storeName => {
    const dynaFormReduce = dynaForms.createReducer(storeName);
    const types = getTypes(storeName);
    return (state = initialState(), action) => {
        state = dynaFormReduce(state, action);

        switch (action.type) {
            case types.AFTER_INITIALIZE:
                return dynaForms.afterInitializeReduce(state);

            case types.SET_REGISTERED_USER:
                return reduceAction(state, 'registeredUser', action.payload);

            case types.SET_STEP:
                return reduceAction(state, 'step', action.payload);

            case types.SET_STEP_BACK:
                return { ...state };

            case types.SET_AGE_VERIFICATION:
                return reduceAction(state, 'isAgeVerified', true);

            case types.RESET_AGE_VERIFICATION:
                return reduceAction(state, 'isAgeVerified', false);
            case types.DISABLE_STEP1_BUTTON:
                return {
                    ...state,
                    ...action.payload,
                };

            case types.REMOVE_PASSWORD_VALIDATION:
                return {
                    ...state,
                    data: {
                        ...state.data,
                        password: {
                            ...state.data.password,
                            constraints: [],
                        },
                        passwordConfirm: {
                            ...state.data.passwordConfirm,
                            constraints: [],
                        },
                    },
                };
            case types.SET_TEMPORARY_DOB_VALIDATION: // TODO: Remove once we have separate form for regristration non-loyalty
                return setTempValidation(state, action.payload, 'dateOfBirth');

            case types.SET_TEMPORARY_GENDER_VALIDATION: // TODO: Remove once we have separate form for regristration non-loyalty
                return setTempValidation(state, action.payload, 'gender');

            case types.SET_IS_PIN_CODE_OR_DOB_VALID:
                return {
                    ...state,
                    ...action.payload,
                };
            case types.SHOW_PINCODE:
                return {
                    ...state,
                    showPincode: action.payload,
                };
            case types.PHONE_DOB_RECEIVED:
                return toggleFakeValidationsForRegistration(state, action.payload);

            case types.SET_IS_LOYALTY:
                return {
                    ...state,
                    isLoyalty: action.payload,
                };
            default:
                return state;
        }
    };
};

export default createReducer;
